module.exports = __webpack_public_path__ + "img/sea-freight.3e62ecc7.png";